export const rootAuthPath = '/auth';
export const providerPath = '/provider';
export const rootMainPath = '/main';
export const errorPath = '/error';
export const noFoundPath = '/404';
export const authPath = {
  signIn: `${rootAuthPath}/sign-in`,
  signUp: `${rootAuthPath}/sign-up`,
  reset: `${rootAuthPath}/reset`,
  passRecovery: `${rootAuthPath}/password-recovery`,
  successfully: `${rootAuthPath}/successfully`,
  successfullyRecovery: `${rootAuthPath}/successfullyRecovery`
};

export const providersPath = {
  google: `${providerPath}/google`,
  facebook: `${providerPath}/facebook`
};
export const policyPath = '/policy';

export const mainPath = {
  companies: `${rootMainPath}/companies`,
  company: `${rootMainPath}/companies/:id`,
  profile: `${rootMainPath}/profile`,
  support: `${rootMainPath}/support`,
  archive: `${rootMainPath}/mail-list`,
  error: `${rootMainPath}/error`,
  home: `${rootMainPath}/home`,
  policy: `${rootMainPath}/policy`,
  project: `${rootMainPath}/projects/:id`,
  projects: `${rootMainPath}/projects`,
  notifications: `${rootMainPath}/notifications`,

  projectsChat: `${rootMainPath}/projects/:id/projects-chat`,
  projectsReports: `${rootMainPath}/projects/:id/projects-reports`,
  projectsDocuments: `${rootMainPath}/projects/:id/projects-documents`,
  projectsDocument: `${rootMainPath}/projects/:id/projects-documents/:documentId`,
  projectDrawing: `${rootMainPath}/projects/:id/projects-drawing/:documentId`,
  projectsDrawing: `${rootMainPath}/projects/:id/projects-drawing`,
  projectEstimate: `${rootMainPath}/projects/:id/projects-estimate/:documentId`,
  projectsEstimate: `${rootMainPath}/projects/:id/projects-estimate`,
  projectsAssessments: `${rootMainPath}/projects/:id/projects-assessments`,
  projectsParticipants: `${rootMainPath}/projects/:id/projects-participants`,
  projectsParticipantsAdd: `${rootMainPath}/projects/:id/projects-participants/add`,
  projectsParticipantsEmployee: `${rootMainPath}/projects/:id/projects-participants/employee/:userId`,
  projectsParticipantsClient: `${rootMainPath}/projects/:id/projects-participants/client/:clientId`,

  projectsNotification: `${rootMainPath}/projects/:id/projects-notification`,
  projectsEditing: `${rootMainPath}/projects/:id/projects-editing`,

  companiesHome: `${rootMainPath}/companies/:id/companies-home`,
  companiesEmployeesAdd: `${rootMainPath}/companies/:id/companies-employees/add`,
  companiesEmployeesSingle: `${rootMainPath}/companies/:id/companies-employees/:employeeId`,
  companiesEmployees: `${rootMainPath}/companies/:id/companies-employees`,
  companiesCustomersSingle: `${rootMainPath}/companies/:id/companies-customers/:clientId`,
  companiesCustomers: `${rootMainPath}/companies/:id/companies-customers`,
  companiesCustomersAdd: `${rootMainPath}/companies/:id/companies-customers/add`,
  companiesDocuments: `${rootMainPath}/companies/:id/companies-documents`,
  companiesNotification: `${rootMainPath}/companies/:id/companies-notification`,
  companiesEditing: `${rootMainPath}/companies/:id/companies-editing`,

  userDetails: `${rootMainPath}/profile/user-details`,
  userNotification: `${rootMainPath}/profile/user-notification`,
  userSettings: `${rootMainPath}/profile/user-settings`,
  userDictionary: `${rootMainPath}/profile/user-dictionary`
};
